module.exports = __webpack_public_path__ + "media/images/voice03-2-afd9b69b826a92293a0c05920ab7207c.jpg";